import * as handler from './handler';
import { PATH_PORTFOLIO_SIZES, PATH_STATE_ABBR, PATH_PROFILE_ICONS } from './path';

const getPortfolioSizes = () =>
  handler.get(PATH_PORTFOLIO_SIZES).then((res) => {
    return res;
  });

const getStateAbbr = (countryId) =>
  handler.get(PATH_STATE_ABBR + countryId).then((res) => {
    return res;
  });

const getProfileIcons = () =>
  handler.get(PATH_PROFILE_ICONS).then((res) => {
    return res;
  });

export default { getPortfolioSizes, getStateAbbr, getProfileIcons };
